var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWorksheet = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.379 1.5C17.7768 1.5001 18.1582 1.6582 18.4395 1.9395L23.5605 7.0605C23.8418 7.3417 23.9999 7.7232 24 8.121V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.3431 22.5 0 21.1569 0 19.5V4.5C0 2.8431 1.3431 1.5 3 1.5H17.379ZM21.879 7.5L18 3.621V7.5H21.879ZM22.5 19.5C22.5 20.3285 21.8285 21 21 21H3C2.1716 21 1.5 20.3285 1.5 19.5V4.5C1.5 3.6716 2.1716 3 3 3H16.5V7.5C16.5 8.3284 17.1715 9 18 9H22.5V19.5ZM12 6H13.5V15H12V6ZM7.5 7.5H6V15H7.5V7.5ZM10.5 9H9V15H10.5V9ZM16.5 10.5H15V15H16.5V10.5ZM4.5 16.5H18V18H4.5V16.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorksheet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/worksheet.f19bafccbc15d28fcc9de9cf78896093.svg";